import Repository from "./Repository";

/*
    API Access (static#49) — THE backend contract, in one place.

    Every /api-access call the frontend makes goes through this module, so a
    change to the contract is a change to this file only.

    GET    /api-access
        -> { status, apigwKeyValue, usagePlanId, callLimitEnabled,
             provisionedAt, rotatedAt, prevExpiresAt,
             usage: [{ date, used, remaining }],
             courseSelection: { wildcard, maxCourses } | null }
           status is one of: none | pending | active | suspended | revoked | failed

    POST   /api-access/provision   body { courseIds: number[] }
        -> { accessKeyId, secretAccessKey, apigwKeyValue }     ONE-TIME REVEAL
           400 { code: "INVALID_ARGUMENT" } when the courses break the plan's
           rules. The server re-derives the cap; the picker only explains it.

    POST   /api-access/rotate
        -> { accessKeyId, secretAccessKey, apigwKeyValue }     ONE-TIME REVEAL
           409 { code: "ROTATION_IN_PROGRESS", prevExpiresAt } when a 7-day
           dual-key grace window is still open.

    PUT    /api-access/call-limit   body { enabled: boolean }
        -> the updated GET shape

    The user is identified from the bearer token injected by Repository.js —
    never from a path or body parameter.
*/

const apiAccess = "/api-access";
const provision = "/api-access/provision";
const rotate = "/api-access/rotate";
const callLimit = "/api-access/call-limit";

const ApiAccessRepository = {
  getApiAccess() {
    return Repository.get(`${apiAccess}`);
  },
  provisionApiAccess(courseIds) {
    return Repository.post(`${provision}`, { courseIds });
  },
  rotateApiAccess() {
    return Repository.post(`${rotate}`);
  },
  setCallLimit(enabled) {
    return Repository.put(`${callLimit}`, { enabled: !!enabled });
  },
};

export default ApiAccessRepository;
